var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"globalTips mb-2 py-1 pl-3 pr-3"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('i',{staticClass:"el-icon-warning mr-2"}),_c('span',[_vm._v("欢迎登录"+_vm._s(_vm.config.shop_name || '')+"！姓名："+_vm._s(_vm.userName)+" 当前时间："+_vm._s(_vm.time))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }